/*eslint no-useless-escape: "error"*/
export const Common = {
  scrollBackUp: () => {
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0;
  },
  inIframe () {
    try {
        return window.self !== window.top;
    } catch (e) {
        return true;
    }
},
getQuerystring(key, default_) {
  if (default_ == null) default_ = "";
// eslint-disable-next-line
  key = key.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
  // eslint-disable-next-line
  var regex = new RegExp("[\\?&]" + key + "=([^&#]*)", "i");
  var qs = regex.exec(window.location.href);
  if (qs == null) return default_;
  else return qs[1];
},
setCookie(name, value, days) {
  var expires = "";
  if (days) {
      var date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "") + expires + ";domain=.youroverseashome.com;path=/";
},
getCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
},
 iframe_resize() {
  try {
    if (Common.inIframe()){
      var body = document.body,
          html = document.documentElement,
          height = Math.max(body.scrollHeight, body.offsetHeight,
              html.clientHeight, html.scrollHeight, html.offsetHeight);
          height = height + 80;

      if (parent.postMessage) {
          parent.postMessage(height, "http://webstage.smartcurrencyexchange.com/");
          //parent.postMessage(height, "https://www.smartcurrencyexchange.com/");
      } else
          console.log('no post message');
    }
  } catch (e) {
      console.log('error post message');
  }
},
trackSignupEvent() {
  try {
    // eslint-disable-next-line
    dataLayer.push({
      event: "YOHFormEventRegistration"
    });
  } catch (e) {console.log(e);}
},
};
